import { Box } from '@chakra-ui/react';
import React from 'react';

import PageContext from '../../templates/context/PageContext';
import FooterAdapter from '../Footer';
import HeaderAdapter from '../HeaderAdapter';
import SEO from '../SEO';

interface LayoutProps {
  seo: React.ComponentProps<typeof SEO>;
  currentPath: string;
  children?: React.ReactNode | React.ReactNode[];
}

const Layout: React.FC<LayoutProps> = ({ seo, currentPath, children }) => {
  const isCareersPage = /^\/careers\//.test(currentPath);
  const isFalconsPage = /^\/falcons\//.test(currentPath);
  const isLcbPage = /^\/lifecareerbalance\//.test(currentPath);
  const isLcbApplyNowPage = /^\/lifecareerbalance\/applynow/.test(currentPath);
  const isLandingPage = /^\/landing\//.test(currentPath);
  const isLifeInsuranceCalculatorPage =
    /^\/insurance\/life-insurance\/how-much-do-i-need/.test(currentPath);

  return (
    <PageContext.Provider value={currentPath}>
      <SEO {...seo} />
      <HeaderAdapter
        isFalconsPage={isFalconsPage}
        isLcbPage={isLcbPage}
        isLcbApplyNowPage={isLcbApplyNowPage}
        isLandingPage={isLandingPage}
      />
      <Box as="main">{children}</Box>

      <Box as="footer">
        <FooterAdapter
          isCareersPage={isCareersPage}
          isFalconsPage={isFalconsPage}
          isLcbPage={isLcbPage}
          isLandingPage={isLandingPage}
        />
      </Box>
    </PageContext.Provider>
  );
};

export default Layout;
